const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/client/components/request-async-storage.external.js");